import { isUniqueBarcode } from "app/common/product";

/**
 * Aturan retur customer untuk produk yang dilacak PER QTY.
 *
 * Produk per qty (`m_product.is_unique_barcode = false`) tidak pernah punya baris
 * `product_codes` — ReceiveOrderItemService sengaja melewatinya saat penerimaan
 * barang. Akibatnya produk seperti ini tidak bisa discan dan tidak bisa
 * ditambahkan lewat jalur barcode; satu-satunya jalan adalah memilih Sales Order
 * lalu mengisi jumlah returnya.
 */

/**
 * Apakah satu baris order dilacak per qty.
 *
 * Bendera dibaca dari `master_product` (ikut di OrderItem delivery order) dengan
 * cadangan `product_variant.product_detail`. Nilai yang tidak ada tetap dianggap
 * barcode unik — lihat alasannya di `isUniqueBarcode`.
 */
export function isPerQtyOrderItem(orderItem) {
  const flag =
    orderItem?.master_product?.is_unique_barcode ??
    orderItem?.product_variant?.product_detail?.is_unique_barcode;
  return !isUniqueBarcode(flag);
}

/**
 * Sisa yang masih boleh diretur: jumlah pada order dikurangi yang sudah diretur.
 *
 * Jalur barcode unik tidak memakai ini — batasnya dijaga oleh unit yang masih
 * berstatus `delivery`.
 */
export function sisaRetur(orderQty, sudahDiretur) {
  return Math.max(0, Number(orderQty ?? 0) - Number(sudahDiretur ?? 0));
}

/**
 * Menjepit jumlah yang diketik kasir ke rentang 1..max. Nilai kosong atau bukan
 * angka dikembalikan sebagai 1, bukan 0/NaN: baris tanpa jumlah tidak punya arti
 * dan akan ditolak backend.
 */
export function clampReturQty(nilai, max) {
  const angka = Number(nilai);
  const batas = Number(max);
  if (!Number.isFinite(angka) || angka < 1) return 1;
  if (Number.isFinite(batas) && angka > batas) return batas;
  return angka;
}
